// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"studio_wrapper__Uq016","main":"studio_main__1aDRG","footer":"studio_footer__2UJ14"};